// VIENAS, iš anksto išspręstas Material Symbols → @fluentui/react-icons lookup —
// naudojamas VISUR vietoj tiesioginio `<span className="material-symbols-outlined">`,
// kad tas pats piktogramos vardas visame projekte visada mapintųsi į TĄ PATĮ Fluent
// komponentą (žr. plano failą — atskiri failai konvertuojami paraleliai, ad hoc
// pasirinkimai kiekviename faile duotų nenuoseklius rezultatus).
//
// Kiekvienas įrašas eksportuoja PATĮ komponentą (ne string vardą), sizeless (1em,
// automatiškai keičiasi dydis pagal font-size) "Regular" variantą — Filled variantas
// (aktyviai/pasirinktai būsenai) pasiekiamas per `{Name}Filled` tą patį baziniu vardu,
// žr. FILLED_MAP žemiau tiems keliems atvejams, kur tai realiai naudojama (pvz. žvaigždutė
// "pasirinkta" būsenoje).
//
// TIKRI SPRAGŲ ATVEJAI (Fluent System Icons yra verslo/produktyvumo programinės įrangos
// rinkinys, ne baldų/stalystės) — šie NETURI gero 1:1 atitikmens, žymimi `null`. Failų
// konvertavimo metu čia reikės custom SVG, stilizuoto pagal Fluent 20/24px kontūro
// konvenciją (žr. plano failą, §5): `chairLegs` (baldo kojelės), `texture` (medžiagos
// tekstūra), `bookshelf` (lentynos su knygomis — bendras `ContentView` naudojamas kaip
// laikinas pakaitalas, bet nėra semantiškai tikslus).
import {
  AddRegular, AddSquareRegular, SubtractRegular, ArchiveRegular, ArchiveArrowBackRegular, ArrowLeftRegular,
  ArrowRightRegular, ArrowUpRegular, AttachRegular, SparkleRegular, WrenchRegular,
  SeatRegular, CheckmarkRegular, CheckmarkCircleRegular, ChevronLeftRegular, ChevronRightRegular,
  DismissRegular, CloudArrowUpRegular, ArrowSwapRegular, CopyRegular, PaymentRegular, CalendarMonthRegular, ListRegular,
  BoardRegular, DeleteRegular, DeleteLinesRegular, DocumentTextRegular, DoorArrowRightRegular,
  DoorArrowLeftRegular, ArrowDownloadRegular, ReOrderDotsVerticalRegular, EditRegular, MailRegular,
  ErrorCircleRegular, CalendarLtrRegular, ChevronUpRegular, ChevronDownRegular, FilterRegular,
  FilterDismissRegular, ArrowExpandRegular, TextBulletListRegular, TextNumberListLtrRegular, ChatMultipleRegular,
  FullScreenMaximizeRegular, GridDotsRegular, QuestionCircleRegular, HomeRegular, ImageRegular,
  ImageOffRegular, InfoRegular, PersonVoiceRegular, BoxRegular, LayerRegular,
  LinkRegular, TagRegular, VehicleTruckRegular, LocationArrowRightRegular, BuildingRegular,
  LocationRegular, LockClosedRegular, ArrowEnterRegular, ArrowExitRegular, PersonSettingsRegular,
  MapRegular, MailReadRegular, NavigationRegular, ArrowDownRegular, NotepadRegular,
  OpenRegular, ArrowMoveRegular, ColorRegular, PersonRegular, CallRegular,
  ImageMultipleRegular, PlayRegular, PlayCircleRegular, ReceiptMoneyRegular, ArrowRedoRegular,
  ArrowSyncRegular, SaveRegular, SavingsRegular, ClockRegular, DataTrendingRegular,
  SearchRegular, SendRegular, ShareRegular, ShoppingBagRegular, CartRegular,
  BotRegular, BuildingShopRegular, RulerRegular, DocumentBulletListRegular, PersonSupportRegular,
  SettingsRegular, ArrowUndoRegular, VideoOffRegular, CubeRegular, WarningRegular,
  ZoomInRegular, BorderAllRegular, BrightnessHighRegular, GiftCardRegular,
  TaskListLtrRegular, ClipboardSearchRegular, CropRegular, DesignIdeasRegular, MoneyRegular,
  PeopleRegular, PeopleTeamRegular, ClothesHangerRegular, ArrowMaximizeVerticalRegular, HistoryRegular,
  LayerDiagonalRegular, GaugeRegular, LightbulbRegular, MailInboxRegular, MoreHorizontalRegular,
  VideoClipRegular, PaymentWirelessRegular, PersonProhibitedRegular, DocumentPdfRegular, MoneySettingsRegular,
  RadioButtonRegular, ReceiptRegular, StarRegular, TableSimpleRegular, TranslateRegular,
  GlobeSearchRegular, TvRegular, ArrowUploadRegular, ShieldCheckmarkRegular, VideoRegular,
  ContentViewRegular, ColumnTripleRegular, AppsListRegular, EyeRegular, EyeOffRegular, TrophyRegular,
  AppsRegular, HeartRegular, HeartFilled, HandshakeRegular,
  ShieldRegular, PasswordRegular, MailInboxArrowDownRegular,
  AlignSpaceBetweenHorizontalRegular, AlignSpaceEvenlyHorizontalRegular,
  ShapesRegular, CallRectangleLandscapeRegular,
  CursorClickRegular, MergeRegular, ZoomOutRegular, PrintRegular,
} from '@fluentui/react-icons';

export const iconMap = {
  // veiksmai
  add: AddRegular, add_box: AddSquareRegular, remove: SubtractRegular, edit: EditRegular, edit_note: EditRegular,
  delete: DeleteRegular, delete_sweep: DeleteLinesRegular, close: DismissRegular, save: SaveRegular,
  content_copy: CopyRegular, download: ArrowDownloadRegular, upload: ArrowUploadRegular, refresh: ArrowSyncRegular,
  autorenew: ArrowSyncRegular, redo: ArrowRedoRegular, undo: ArrowUndoRegular, send: SendRegular,
  share: ShareRegular, search: SearchRegular, search_off: SearchRegular, filter_list: FilterRegular,
  filter_list_off: FilterDismissRegular, sync: ArrowSyncRegular, fullscreen: FullScreenMaximizeRegular, fit_screen: ArrowExpandRegular,
  open_in_full: ArrowExpandRegular, open_in_new: OpenRegular, open_with: ArrowMoveRegular, zoom_in: ZoomInRegular,
  zoom_out: ZoomOutRegular, print: PrintRegular,
  drag_indicator: ReOrderDotsVerticalRegular, more_horiz: MoreHorizontalRegular, tune: SettingsRegular, settings: SettingsRegular,
  attach_file: AttachRegular, translate: TranslateRegular, touch_app: CursorClickRegular, merge: MergeRegular,

  // navigacija / rodyklės
  arrow_back: ArrowLeftRegular, arrow_forward: ArrowRightRegular, arrow_upward: ArrowUpRegular, move_up: ArrowUpRegular,
  move_down: ArrowDownRegular, chevron_left: ChevronLeftRegular, chevron_right: ChevronRightRegular, expand_less: ChevronUpRegular,
  expand_more: ChevronDownRegular, compare_arrows: ArrowSwapRegular, login: ArrowEnterRegular, logout: ArrowExitRegular,
  menu: NavigationRegular,

  // būsenos / atsiliepimai
  check: CheckmarkRegular, check_circle: CheckmarkCircleRegular, verified: CheckmarkCircleRegular, error: ErrorCircleRegular,
  error_outline: ErrorCircleRegular, warning: WarningRegular, info: InfoRegular, help_outline: QuestionCircleRegular,
  radio_button_unchecked: RadioButtonRegular, verified_user: ShieldCheckmarkRegular,

  // dokumentai / turinys
  description: DocumentTextRegular, article: DocumentTextRegular, notes: NotepadRegular, summarize: DocumentBulletListRegular,
  picture_as_pdf: DocumentPdfRegular, format_list_bulleted: TextBulletListRegular, format_list_numbered: TextNumberListLtrRegular, checklist: TaskListLtrRegular,
  content_paste_search: ClipboardSearchRegular, align_justify_space_between: AlignSpaceBetweenHorizontalRegular, align_justify_space_even: AlignSpaceEvenlyHorizontalRegular, border_all: BorderAllRegular,
  crop_square: CropRegular, layers: LayerRegular, layers_clear: LayerDiagonalRegular, table_bar: TableSimpleRegular,
  table_rows: TableSimpleRegular, view_column: ColumnTripleRegular, view_quilt: AppsListRegular, view_stream: ContentViewRegular,
  view_agenda: ContentViewRegular, view_list: ListRegular, grid_view: GridDotsRegular, dashboard: BoardRegular, space_dashboard: BoardRegular,
  archive: ArchiveRegular, unarchive: ArchiveArrowBackRegular, link: LinkRegular, palette: ColorRegular, texture: null, // TIKRA SPRAGA — reikės custom SVG
  category: ShapesRegular, crop_landscape: CallRectangleLandscapeRegular,

  // vaizdai / medija
  image: ImageRegular, image_not_supported: ImageOffRegular, photo_library: ImageMultipleRegular, videocam_off: VideoOffRegular,
  videocam: VideoRegular, video_camera: VideoRegular, movie: VideoRegular, movie_filter: VideoClipRegular, play_arrow: PlayRegular,
  play_circle: PlayCircleRegular, view_in_ar: CubeRegular, brightness_high: BrightnessHighRegular, lightbulb: LightbulbRegular,

  // žmonės / kontaktai
  person: PersonRegular, person_off: PersonProhibitedRegular, group: PeopleRegular, groups: PeopleTeamRegular,
  manage_accounts: PersonSettingsRegular, interpreter_mode: PersonVoiceRegular, support_agent: PersonSupportRegular, phone: CallRegular,
  email: MailRegular, mail: MailRegular, mail_outline: MailRegular, mark_email_read: MailReadRegular,
  markunread_mailbox: MailInboxRegular, inbox: MailRegular, forum: ChatMultipleRegular, move_to_inbox: MailInboxArrowDownRegular,

  // vieta / pristatymas
  map: MapRegular, location_on: LocationRegular, location_city: BuildingRegular, location_away: LocationArrowRightRegular,
  local_shipping: VehicleTruckRegular, travel_explore: GlobeSearchRegular, home: HomeRegular, home_repair_service: WrenchRegular,
  night_shelter: HomeRegular, storefront: BuildingShopRegular, store: BuildingShopRegular,

  // pirkiniai / mokėjimai
  shopping_cart: CartRegular, shopping_bag: ShoppingBagRegular, remove_shopping_cart: CartRegular, card_giftcard: GiftCardRegular,
  credit_card: PaymentRegular, payments: PaymentWirelessRegular, receipt: ReceiptRegular, receipt_long: ReceiptMoneyRegular,
  local_offer: TagRegular, sell: TagRegular, savings: SavingsRegular, euro: MoneyRegular,
  price_check: MoneySettingsRegular,

  // baldai / gamyba (dalinai spragos, žr. viršuje esančią pastabą)
  chair: SeatRegular, legs: null, shelves: ContentViewRegular, drawer: ArchiveRegular,
  dresser: ContentViewRegular, hanger: ClothesHangerRegular, door: DoorArrowRightRegular, door_back: DoorArrowLeftRegular,
  door_front: DoorArrowRightRegular, door_open: DoorArrowLeftRegular, door_sensor: DoorArrowRightRegular, door_sliding: DoorArrowRightRegular,
  build: WrenchRegular, construction: WrenchRegular, handyman: WrenchRegular, precision_manufacturing: WrenchRegular,
  screwdriver: WrenchRegular, hardware: WrenchRegular, drill: WrenchRegular, straighten: RulerRegular,
  height: ArrowMaximizeVerticalRegular, level: GaugeRegular, foundation: LayerRegular, pantograph: ArrowMaximizeVerticalRegular,
  pullout: ArrowMoveRegular, inventory_2: BoxRegular, design_services: DesignIdeasRegular,

  // paskata / dirbtinis intelektas
  auto_awesome: SparkleRegular, smart_toy: BotRegular, workspace_premium: TrophyRegular, workspaces: AppsRegular,
  star: StarRegular, schema: DataTrendingRegular, event: CalendarLtrRegular, schedule: ClockRegular,
  history: HistoryRegular, tv: TvRegular, cloud_upload: CloudArrowUpRegular, visibility: EyeRegular, visibility_off: EyeOffRegular, calendar_month: CalendarMonthRegular,
  lock: LockClosedRegular, favorite_border: HeartRegular, favorite: HeartFilled,
  handshake: HandshakeRegular,

  // autentifikacija (2FA, slaptažodžio atstatymas)
  shield: ShieldRegular, lock_reset: PasswordRegular,
};

// Fluent Filled variantai (importuojami tik ten, kur realiai naudojami — "aktyvi"/"pasirinkta"
// būsena, pvz. žvaigždutė mėgstamiausio žymėjime), papildomi PO POREIKIO konvertuojant
// konkretų failą, ne visi 176 iš karto (dauguma vietų naudoja tik Regular).
export { StarFilled, CheckmarkCircleFilled, CartFilled, HeartFilled, CheckmarkFilled } from '@fluentui/react-icons';
